import AuthApp from '../apps/auth/AuthApp.vue';
import createAuthRouter from '../router/authApp.js';
import {setupSPA} from '../utils/setupApp.js';

window.setupAuthApp = (params) => {
  const router = createAuthRouter();
  setupSPA(AuthApp, {
    ...params,
    router,
  });
};
